import { DialogType } from '../../admin/AdminEventUsers/useAdminEventUsers';
import { User } from '../../apollo/__generated__/graphql';
import { useCurrentUserQuery } from '../../user/hooks/useCurrentUserQuery';
import { useCurrentEventQuery } from './useCurrentEventQuery';
import { useUpdateUserValidatedMutation } from './useUpdateUserValidatedMutation';

export const useUpdateValidation = (
  setDialog: (dialog: DialogType | null) => void,
) => {
  const { data: currentEventData } = useCurrentEventQuery();
  const { updateUserValidated } = useUpdateUserValidatedMutation();
  const { data: currentUserData } = useCurrentUserQuery();

  const onValidatePress = (user: User) => {
    if (!currentUserData?.currentUser?.isAdmin) {
      setDialog({
        title: 'Contactez un admin',
        description: `Valider un paiement nécessite des droits d'administrateur. Contactez un administrateur pour effectuer cette action.`,
        onSubmit: () => {
          setDialog(null);
        },
      });
      return;
    }
    const eventId = currentEventData?.currentEvent?.id ?? null;
    if (!eventId) {
      return;
    }
    if (user.isValidated) {
      setDialog({
        title: 'Invalider cette personne',
        description: `Êtes-vous sûr de vouloir invalider la participation de ${user.firstname} ${user.lastname} ?`,
        onSubmit: () => {
          updateUserValidated({
            eventId,
            isValidated: false,
            userId: user.id,
          });
          setDialog(null);
        },
      });
    } else {
      updateUserValidated({
        eventId,
        isValidated: true,
        userId: user.id,
      });
    }
  };

  return { onValidatePress };
};
